import { render, staticRenderFns } from "./PagesDropdown.vue?vue&type=template&id=081f96cc&"
import script from "./PagesDropdown.vue?vue&type=script&lang=js&"
export * from "./PagesDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports